module.exports = __webpack_public_path__ + "static/media/logo21.1b2e5f3e.png";